import { COLOR } from '../actions/colors';
import { BUILDER_TYPES } from '../../config/constants';


const DEFAULT_COLOR_STATE = {
    elementColor: '#00205C',
    backgroundColor: '#F4F4F7',
    textColor: '#000000',
}

const DEFAULT_STATE = {
    [BUILDER_TYPES.FORM]: {...DEFAULT_COLOR_STATE},
    [BUILDER_TYPES.SUCCESS_PAGE]: {...DEFAULT_COLOR_STATE}
};

export default (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case COLOR:
            const { activeBuilderType, targetColor, color } = action.payload;
            const curValue = state[activeBuilderType];
            return {
                ...state,
                [activeBuilderType]: { ...curValue, [targetColor]: color }
            }

        default: return state;
    }
}
